export default __webpack_public_path__ + "static/media/kubernetes.31884a04.svg";